import React from 'react';
import { Star } from 'lucide-react';
const testimonials = [{
  initials: 'MP',
  name: 'Martín P.',
  loc: 'Buenos Aires 🇦🇷',
  color: 'bg-blue-100 text-blue-700',
  quote: 'Compré un sábado. El domingo a la noche tenía el mes de clases listo. Nunca más improviso.'
}, {
  initials: 'CG',
  name: 'Claudia G.',
  loc: 'Córdoba 🇦🇷',
  color: 'bg-purple-100 text-purple-700',
  quote: 'Tres alumnos adultos iniciales que estaban estancados mejoraron su flotación en el primer mes con el Tomo 5.'
}, {
  initials: 'FR',
  name: 'Federico R.',
  loc: 'Rosario 🇦🇷',
  color: 'bg-green-100 text-green-700',
  quote: 'Antes tardaba 1 hora armando una clase. Ahora son 5 minutos. El sistema de fichas graficadas es una locura.'
}, {
  initials: 'SV',
  name: 'Sofía V.',
  loc: 'Mendoza 🇦🇷',
  color: 'bg-pink-100 text-pink-700',
  quote: 'El Bonus de Escáner de Niveles cambió cómo evalúo a mis alumnos. Ahora sé exactamente en qué tomo tiene que estar cada uno y por qué.'
}, {
  initials: 'DA',
  name: 'Diego A.',
  loc: 'Santa Fe 🇦🇷',
  color: 'bg-yellow-100 text-yellow-700',
  quote: 'El Ebook Elite de Competencia me salvó cuando tuve que preparar a dos alumnos para el torneo del club. Supe exactamente qué hacer semana a semana.'
}, {
  initials: 'CR',
  name: 'Carolina R.',
  loc: 'Tucumán 🇦🇷',
  color: 'bg-teal-100 text-teal-700',
  quote: 'El Planificador Anual cambió mi relación con la enseñanza. Llego a la pileta con energía porque ya tengo todo pensado desde el domingo.'
}];
export function ExtendedTestimonials() {
  return <section className="py-20 bg-gray-50" data-id="element-89">
      <div className="max-w-6xl mx-auto px-4" data-id="element-90">
        <div className="text-center mb-12" data-id="element-91">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-gray-900 mb-4" data-id="element-92">
            Lo que dicen los profesores
          </h2>
          <div className="flex items-center justify-center gap-2 text-2xl font-bold text-gray-900" data-id="element-93">
            4.9/5 <Star className="w-6 h-6 fill-yellow-400 text-yellow-400" data-id="element-94" />
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-95">
          {testimonials.map((t, i) => <div key={i} className="bg-white rounded-2xl p-8 shadow-sm border border-gray-200" data-id="element-96">
              <div className="flex items-center gap-4 mb-6" data-id="element-97">
                <div className={`w-14 h-14 rounded-full flex items-center justify-center font-bold text-xl ${t.color}`} data-id="element-98">
                  {t.initials}
                </div>
                <div data-id="element-99">
                  <div className="font-bold text-gray-900" data-id="element-100">{t.name}</div>
                  <div className="text-sm text-gray-500" data-id="element-101">{t.loc}</div>
                </div>
              </div>
              <div className="flex gap-1 mb-4" data-id="element-102">
                {[...Array(5)].map((_, j) => <Star key={j} className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-103" />)}
              </div>
              <p className="text-gray-700 italic leading-relaxed" data-id="element-104">
                "{t.quote}"
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}